import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pageTitle: {
    id: 'App.ManageHUDVouchers.PageTitle',
    defaultMessage: 'Manage HUD Vouchers - {propertyName}',
  },
  header: {
    id: 'App.ManageHUDVouchers.Header',
    defaultMessage: 'Manage HUD Vouchers',
  },
  description: {
    id: 'App.ManageHUDVouchers.Description',
    defaultMessage:
      'To review or submit your Voucher, click on the Voucher Year-Month.',
  },
  voucherYearMonth: {
    id: 'App.ManageHUDVouchers.Table.VoucherYearMonth',
    defaultMessage: 'Voucher Year-Month',
  },
  tracsVoucherId: {
    id: 'App.ManageHUDVouchers.Table.TracsVoucherId',
    defaultMessage: 'TRACS Voucher ID',
  },
  subsidyUnits: {
    id: 'App.ManageHUDVouchers.Table.SubsidyUnits',
    defaultMessage: 'Contract Units',
  },
  subsidyType: {
    id: 'App.ManageHUDVouchers.Table.SubsidyType',
    defaultMessage: 'Subsidy Type',
  },
  contractNumber: {
    id: 'App.ManageHUDVouchers.Table.ContractNumber',
    defaultMessage: 'Contract Number',
  },
  submissionStatus: {
    id: 'App.ManageHUDVouchers.Table.SubmissionStatus',
    defaultMessage: 'Submission Status',
  },
  lastSubmissionDate: {
    id: 'App.ManageHUDVouchers.Table.LastSubmissionDate',
    defaultMessage: 'Last Submission Date and Time',
  },
  hudResponseDate: {
    id: 'App.ManageHUDVouchers.Table.HudResponseDate',
    defaultMessage: 'HUD Response Date',
  },
  totalVoucherAmount: {
    id: 'App.ManageHUDVouchers.Table.TotalVoucherAmount',
    defaultMessage: 'Total Voucher Amount',
  },
  tracsMessage: {
    id: 'App.ManageHUDVouchers.Table.TracsMessage',
    defaultMessage: 'TRACS Message',
  },
  actions: {
    id: 'App.ManageHUDVouchers.Table.Actions',
    defaultMessage: 'Actions',
  },
  download: {
    id: 'App.ManageHUDVouchers.Table.Download',
    defaultMessage: 'Download',
  },
  downloadHud52670: {
    id: 'App.ManageHUDVouchers.Table.DownloadHud52670',
    defaultMessage: 'Download HUD 52670',
  },
  downloadMat30: {
    id: 'App.ManageHUDVouchers.Table.DownloadMat30',
    defaultMessage: 'Download MAT30',
  },
  setUp: {
    id: 'App.ManageHUDVouchers.SetUp',
    defaultMessage: 'Set Up',
  },
  manageSetup: {
    id: 'App.ManageHUDVouchers.ManageSetup',
    defaultMessage: 'Manage Setup',
  },
  loadError: {
    id: 'App.ManageHUDVouchers.LoadError',
    defaultMessage: 'Failed to load HUD vouchers. Please try again.',
  },
  loadErrorTitle: {
    id: 'App.ManageHUDVouchers.LoadErrorTitle',
    defaultMessage: 'Error Loading Vouchers',
  },
  setupSuccess: {
    id: 'App.ManageHUDVouchers.SetupSuccess',
    defaultMessage: 'Vouchers created successfully.',
  },
  updateSuccess: {
    id: 'App.ManageHUDVouchers.UpdateSuccess',
    defaultMessage: 'Begin date updated successfully.',
  },
  undoSuccess: {
    id: 'App.ManageHUDVouchers.UndoSuccess',
    defaultMessage: 'Voucher setup undone successfully.',
  },
  emptyStateMessage: {
    id: 'App.ManageHUDVouchers.Table.EmptyStateMessage',
    defaultMessage: 'There are no HUD vouchers to show',
  },
  downloadingMat30: {
    id: 'App.ManageHUDVouchers.DownloadingMat30',
    defaultMessage: 'Downloading MAT30 file...',
  },
  downloadMat30Error: {
    id: 'App.ManageHUDVouchers.DownloadMat30Error',
    defaultMessage: 'Failed to download MAT30 file.',
  },
  noPermissionTooltip: {
    id: 'App.ManageHUDVouchers.NoPermissionTooltip',
    defaultMessage: 'You do not have permission to perform this action.',
  },
});

export default messages;
